// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"styles__checkboxWrapper___30z1i","checkboxLabel":"styles__checkboxLabel___3hm1L","textAction":"styles__textAction___2qSew","actions":"styles__actions___16V07"};